"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseError = exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["UNIDENTIFIED"] = 0] = "UNIDENTIFIED";
    ErrorCode[ErrorCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ErrorCode[ErrorCode["NOT_FOUND"] = 404] = "NOT_FOUND";
    ErrorCode[ErrorCode["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    ErrorCode[ErrorCode["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
var BaseError = /** @class */ (function () {
    function BaseError(message, code, status, errors, data) {
        if (message === void 0) { message = 'Error. Please Try Again.'; }
        if (status === void 0) { status = ErrorCode.UNIDENTIFIED; }
        if (errors === void 0) { errors = {}; }
        if (data === void 0) { data = {}; }
        this.message = message;
        this.code = code;
        this.status = status;
        this.errors = errors;
        this.data = data;
    }
    BaseError.from = function (axiosError) {
        if (!axiosError.response) {
            return new BaseError();
        }
        var _a = axiosError.response, status = _a.status, data = _a.data;
        if (status === ErrorCode.UNPROCESSABLE_ENTITY) {
            return new BaseError(data === null || data === void 0 ? void 0 : data.message, data === null || data === void 0 ? void 0 : data.code, status, data === null || data === void 0 ? void 0 : data.errors, data === null || data === void 0 ? void 0 : data.data);
        }
        return new BaseError(data === null || data === void 0 ? void 0 : data.message, data === null || data === void 0 ? void 0 : data.code, status, null, data === null || data === void 0 ? void 0 : data.data);
    };
    BaseError.prototype.errorsByKey = function (key) {
        var _a;
        return (_a = this.errors) === null || _a === void 0 ? void 0 : _a[key];
    };
    BaseError.prototype.hasErrorByKey = function (key) {
        return !!this.errorsByKey(key);
    };
    return BaseError;
}());
exports.BaseError = BaseError;
